module.exports = __webpack_public_path__ + "media/images/icon-search@3x-d94a1eff53b2ef11b6c43d87163e1c97.png";